import Vue from 'vue'

export default ({
  namespaced: true,
  state: {
    view: 'selectedBoard',
    values: {id: '', team_id: null, tasktemplate_id: null, properties: {}},
    properties_add_task: {openTask: true, values: {}},
    // Loaded criado para verificar se é necessário buscar novamente os registros do banco. Sempre que é alterado alguma prop, deve ser carregado a variavel properties_add_task quando o usuário quer adicionar
    loaded_properties_add_task: false,
    // taskFilters armazena todos os valores que são usados no filtro
    taskFilters: {createdByUser: [], defaultStatus: [], taskCategories: [], taskClients: [], taskStatus: [], taskTeams: [], taskTemplates: [], taskUsers: []},
    // verifica se os valores do taskFilters já fora buscados
    loaded_taskFilters: false
  },
  getters: {
    values: state => {
      return state.values
    },
    id: state => {
      return state.values['id']
    },
    properties: state => {
      return state.values.properties
    },
    properties_add_task: state => {
      return state.properties_add_task
    },
    loaded: state => {
      return state.loaded_properties_add_task
    },
    taskFilters: state => {
      return state.values.taskFilters
    }
  },
  mutations: {
    change_board (state, payload) {
      state.loaded_properties_add_task = false
      Object.assign(state.values, payload)
      // Caso as propriedades venhacomo string passa elas para objeto
      if (payload['properties'] && ((typeof payload['properties']) === 'string')) Object.assign(state.values.properties, JSON.parse(payload.properties))
    },
    change_props (state, payload) {
      state.loaded_properties_add_task = false
      Object.assign(state.values.properties, payload)
    }
  },
  actions: {
    propertiesAddTask (context) {
      return new Promise((resolve, reject) => {
        if (context.state.loaded_properties_add_task) {
          resolve(context.state.properties_add_task)
        } else {
          Vue.http.post('api/check_properties_add_task', context.state.values.properties).then((res) => {
            context.state.loaded_properties_add_task = true
            context.state.properties_add_task = res.body
            resolve(res.body)
          }, (err) => {
            console.log(err)
            Vue.store.commit('snackbar/change_values', {
              text: 'Não foi possível buscar os valores! Favor reporte o erro.',
              color: 'error',
              dialog: true
            })
            reject(err)
          })
        }
      })
    },
    // getTaskFilters usado para buscar todos os dados que são usados nos filtros
    // val usado para buscar dados especificos
    getTaskFilters (context, params = '') {
      console.log('getTaskFilters', params)
      return new Promise((resolve, reject) => {
        // caso o loaded esteja true e não tenha vindo o params então significa que os dados já foram buscados.
        // if (context.state.loaded_taskFilters && params === '') {
        //   resolve(context.state.taskFilters)
        // } else {
        // caso seja necessário buscar os dados, busca no banco, e se tiver um type no params, passa para buscar aqueles dados especificos
        // passa o board_id para buscar os itens dos campos de acordo com os registros selecionados na area de trabalho, nos casos do filtros individual
        Vue.http.get(`api/get_task_filters?${params['type'] ? 'type=' + params['type'] : ''}${params['board_id'] ? '&board_id=' + params['board_id'] : ''}`).then(res => {
          // caso não tenha o id do board não sendo do filtro individual e caso o taskUsers tenha vindo adicionar a opção todos menos eu
          if (!params['board_id'] && res.body['taskUsers']) res.body['taskUsers'].unshift({id: 'allLess', id_text: 'Todos menos eu'})
          context.state.loaded_taskFilters = true
          Object.assign(context.state.taskFilters, res.body)
          // verifica se os valores estão na lista
          // this.checkProperties()
          resolve(res.body)
        }, err => {
          reject(err)
        })
        // }
      })
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/selectedBoard.js